module.exports = __webpack_public_path__ + "static/media/mg.cbca1706.svg";